import { render, staticRenderFns } from "./detailsfuwu.vue?vue&type=template&id=379a9966&scoped=true&"
import script from "./detailsfuwu.vue?vue&type=script&lang=js&"
export * from "./detailsfuwu.vue?vue&type=script&lang=js&"
import style0 from "./detailsfuwu.vue?vue&type=style&index=0&id=379a9966&prod&lang=less&scoped=true&"
import style1 from "./detailsfuwu.vue?vue&type=style&index=1&id=379a9966&prod&lang=css&"
import style2 from "./detailsfuwu.vue?vue&type=style&index=2&id=379a9966&prod&lang=less&scoped=true&"
import style3 from "./detailsfuwu.vue?vue&type=style&index=3&id=379a9966&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a9966",
  null
  
)

export default component.exports